module.exports = __webpack_public_path__ + "media/images/technology/honor-icon-2f99ed915b48adcbad20f40df06d1810.png";